export default __webpack_public_path__ + "static/media/love1.06270fce.jpg";